"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.date.to-iso-string.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.timers.js");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
/* eslint-disable max-classes-per-file */
/* global WorkerGlobalScope */

if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
  var KEEP_ALIVE_LOCAL_STORAGE_NAME = 'KeepAlive.expirationDate';
  var KEEP_ALIVE_REFRESH_TIMESTAMP_NAME = 'KeepAlive.lastRefreshTimestamp';
  var KEEP_ALIVE_BEFORE_REFRESH_DURATION = 10000;
  var KEEP_ALIVE_VALIDITY_CHECK_DURATION = 10000;
  var MINIMUM_TIMEOUT_DURATION = 1000;
  var KEEP_ALIVE_EXPIRATION_ENDPOINT = '/services/accessToken/expiration';
  var KEEP_ALIVE_REFRESH_ENDPOINT = '/services/refresh';
  var REFRESH_COOLDOWN_DURATION = 5000;
  var KEEP_ALIVE_REDIRECT_URL = '/authentication/oauth2/authorization/reach-five?callback=';
  var KEEPALIVE_INIT_MAX_RETRIES = 5;
  var KEEPALIVE_REFRESH_MAX_RETRIES = 3;
  var KEEPALIVE_RETRY_BASE_DELAY = 1000; // base delay in ms
  var KEEPALIVE_RETRY_MAX_DELAY = 30000; // max delay in ms
  var KEEPALIVE_RETRY_BACKOFF_FACTOR = 2; // backoff factor

  var KEEPALIVE_REDIRECT_MESSAGE_TYPE = "redirectToAuthorize";

  // Web Locks API constants
  var KEEP_ALIVE_LOCK_NAME = 'keep-alive-lock';
  var Storage = /*#__PURE__*/function () {
    function Storage() {
      (0, _classCallCheck2["default"])(this, Storage);
      this.resolvers = {};
      this.messageHandler = this.messageHandler.bind(this);
      onmessage = this.messageHandler;
    }
    return (0, _createClass2["default"])(Storage, [{
      key: "setItem",
      value: function setItem(key, value) {
        postMessage({
          type: 'setItem',
          args: [key, value]
        });
      }
    }, {
      key: "removeItem",
      value: function removeItem(key) {
        postMessage({
          type: 'removeItem',
          args: [key]
        });
      }
    }, {
      key: "getItem",
      value: function getItem(key) {
        var _this = this;
        return new Promise(function (resolve) {
          var id = "id".concat(new Date().getTime()).concat(Math.round(Math.random() * 100000));
          _this.resolvers[id] = resolve;
          postMessage({
            type: 'getItem',
            args: [key],
            id: id
          });
        });
      }
    }, {
      key: "getCallbackUrl",
      value: function getCallbackUrl() {
        var _this2 = this;
        return new Promise(function (resolve) {
          var id = "id".concat(new Date().getTime()).concat(Math.round(Math.random() * 100000));
          _this2.resolvers[id] = resolve;
          postMessage({
            type: 'getCallbackUrl',
            id: id
          });
        });
      }
    }, {
      key: "messageHandler",
      value: function messageHandler(_ref) {
        var eventData = _ref.data;
        var resolver = this.resolvers[eventData === null || eventData === void 0 ? void 0 : eventData.id];
        if (resolver) {
          resolver(eventData.data);
          delete this.resolvers[eventData.id];
        }
      }
    }]);
  }();
  var RetryHandler = /*#__PURE__*/function () {
    function RetryHandler(maxRetries, baseDelay, maxDelay, backoffFactor) {
      (0, _classCallCheck2["default"])(this, RetryHandler);
      this.maxRetries = maxRetries;
      this.baseDelay = baseDelay;
      this.maxDelay = maxDelay;
      this.backoffFactor = backoffFactor;
      this.retryCount = 0;
    }
    return (0, _createClass2["default"])(RetryHandler, [{
      key: "getNextDelay",
      value: function getNextDelay() {
        var exponentialDelay = Math.min(this.maxDelay, this.baseDelay * Math.pow(this.backoffFactor, this.retryCount));
        var jitter = 0.2;
        var randomFactor = 1 - jitter + Math.random() * jitter * 2;
        return Math.floor(exponentialDelay * randomFactor);
      }
    }, {
      key: "canRetry",
      value: function canRetry() {
        return this.retryCount < this.maxRetries;
      }
    }, {
      key: "incrementRetry",
      value: function incrementRetry() {
        this.retryCount++;
        return this.retryCount;
      }
    }, {
      key: "reset",
      value: function reset() {
        this.retryCount = 0;
      }
    }]);
  }();
  var KeepAliveWorker = /*#__PURE__*/function () {
    function KeepAliveWorker() {
      (0, _classCallCheck2["default"])(this, KeepAliveWorker);
      this.storage = new Storage();
      this.locksManager = new WebLocksManager();
      this.initRetryHandler = new RetryHandler(KEEPALIVE_INIT_MAX_RETRIES, KEEPALIVE_RETRY_BASE_DELAY, KEEPALIVE_RETRY_MAX_DELAY, KEEPALIVE_RETRY_BACKOFF_FACTOR);
      this.refreshRetryHandler = new RetryHandler(KEEPALIVE_REFRESH_MAX_RETRIES, KEEPALIVE_RETRY_BASE_DELAY, KEEPALIVE_RETRY_MAX_DELAY, KEEPALIVE_RETRY_BACKOFF_FACTOR);
      this.initKeepAlive();
    }
    return (0, _createClass2["default"])(KeepAliveWorker, [{
      key: "saveExpirationDate",
      value: function saveExpirationDate(expirationDateString) {
        this.storage.setItem(KEEP_ALIVE_LOCAL_STORAGE_NAME, expirationDateString);
      }
    }, {
      key: "saveRefreshTimestamp",
      value: function saveRefreshTimestamp() {
        var timestamp = new Date().getTime().toString();
        this.storage.setItem(KEEP_ALIVE_REFRESH_TIMESTAMP_NAME, timestamp);
      }
    }, {
      key: "getLastRefreshTimestamp",
      value: function () {
        var _getLastRefreshTimestamp = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var timestampString;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.storage.getItem(KEEP_ALIVE_REFRESH_TIMESTAMP_NAME);
              case 2:
                timestampString = _context.sent;
                return _context.abrupt("return", timestampString ? parseInt(timestampString, 10) : 0);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function getLastRefreshTimestamp() {
          return _getLastRefreshTimestamp.apply(this, arguments);
        }
        return getLastRefreshTimestamp;
      }()
    }, {
      key: "wasRecentlyRefreshed",
      value: function () {
        var _wasRecentlyRefreshed = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var lastRefreshTimestamp, currentTime, timeSinceLastRefresh;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getLastRefreshTimestamp();
              case 2:
                lastRefreshTimestamp = _context2.sent;
                currentTime = new Date().getTime();
                timeSinceLastRefresh = currentTime - lastRefreshTimestamp;
                return _context2.abrupt("return", timeSinceLastRefresh < REFRESH_COOLDOWN_DURATION);
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function wasRecentlyRefreshed() {
          return _wasRecentlyRefreshed.apply(this, arguments);
        }
        return wasRecentlyRefreshed;
      }()
    }, {
      key: "getTimeoutDuration",
      value: function getTimeoutDuration() {
        var currentTime = new Date().getTime();
        var expirationTime = this.expirationDate.getTime();
        var timeoutDuration = expirationTime - currentTime - KEEP_ALIVE_BEFORE_REFRESH_DURATION;
        if (timeoutDuration <= 0) {
          console.warn('Keepalive expiration too close or passed, refreshing soon', {
            expirationTime: expirationTime,
            currentTime: currentTime,
            difference: expirationTime - currentTime
          });
          return MINIMUM_TIMEOUT_DURATION;
        }
        return timeoutDuration;
      }
    }, {
      key: "getTokenExpirationDate",
      value: function () {
        var _getTokenExpirationDate = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var expirationDateString, expirationDate, response, data;
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.storage.getItem(KEEP_ALIVE_LOCAL_STORAGE_NAME);
              case 2:
                expirationDateString = _context3.sent;
                if (!expirationDateString) {
                  _context3.next = 7;
                  break;
                }
                expirationDate = new Date(expirationDateString);
                if (!(expirationDate.getTime() > new Date().getTime() - KEEP_ALIVE_VALIDITY_CHECK_DURATION)) {
                  _context3.next = 7;
                  break;
                }
                return _context3.abrupt("return", expirationDate);
              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return fetch(KEEP_ALIVE_EXPIRATION_ENDPOINT);
              case 10:
                response = _context3.sent;
                _context3.next = 13;
                return response.json();
              case 13:
                data = _context3.sent;
                expirationDateString = data;
                if (!expirationDateString) {
                  _context3.next = 19;
                  break;
                }
                this.saveExpirationDate(expirationDateString);
                this.initRetryHandler.reset();
                return _context3.abrupt("return", new Date(expirationDateString));
              case 19:
                _context3.next = 24;
                break;
              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](7);
                console.error('Keepalive expiration date fetch error', _context3.t0);
              case 24:
                return _context3.abrupt("return", undefined);
              case 25:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this, [[7, 21]]);
        }));
        function getTokenExpirationDate() {
          return _getTokenExpirationDate.apply(this, arguments);
        }
        return getTokenExpirationDate;
      }()
    }, {
      key: "refreshToken",
      value: function () {
        var _refreshToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
          var _this3 = this;
          var refreshOperation, result, retryCount, delay;
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                refreshOperation = /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
                    var startTime, refreshUrl, res, responseText, response, endTime;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this3.wasRecentlyRefreshed();
                        case 2:
                          if (!_context4.sent) {
                            _context4.next = 5;
                            break;
                          }
                          console.log('🚫 Token already refreshed recently, skipping refresh');
                          return _context4.abrupt("return", 'ALREADY_REFRESHED');
                        case 5:
                          startTime = new Date().toISOString();
                          console.log("\uD83D\uDD04 Starting keepalive token refresh at ".concat(startTime));
                          _this3.saveRefreshTimestamp();
                          _context4.prev = 8;
                          refreshUrl = "".concat(KEEP_ALIVE_REFRESH_ENDPOINT, "?isKeepalive=true");
                          _context4.next = 12;
                          return fetch(refreshUrl, {
                            method: 'GET',
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });
                        case 12:
                          res = _context4.sent;
                          if (res.ok) {
                            _context4.next = 15;
                            break;
                          }
                          throw new Error("HTTP error! Status: ".concat(res.status));
                        case 15:
                          _context4.next = 17;
                          return res.text();
                        case 17:
                          responseText = _context4.sent;
                          _context4.prev = 18;
                          response = JSON.parse(responseText);
                          _context4.next = 26;
                          break;
                        case 22:
                          _context4.prev = 22;
                          _context4.t0 = _context4["catch"](18);
                          console.error('Keepalive refresh token response parse error', _context4.t0, responseText);
                          throw new Error('Failed to parse refresh response');
                        case 26:
                          if (response && response.needRefreshScope === true) {
                            _this3.redirectToAuthorize();
                          }
                          endTime = new Date().toISOString();
                          console.log("\u2705 Ended keepalive token refresh at ".concat(endTime));
                          return _context4.abrupt("return", 'SUCCESS');
                        case 32:
                          _context4.prev = 32;
                          _context4.t1 = _context4["catch"](8);
                          console.error('Keepalive refresh token error', _context4.t1);
                          throw _context4.t1;
                        case 36:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[8, 32], [18, 22]]);
                  }));
                  return function refreshOperation() {
                    return _ref2.apply(this, arguments);
                  };
                }();
                _context5.prev = 1;
                _context5.next = 4;
                return this.locksManager.acquireLockAndExecute(KEEP_ALIVE_LOCK_NAME, refreshOperation);
              case 4:
                result = _context5.sent;
                if (!(result === null)) {
                  _context5.next = 10;
                  break;
                }
                console.log('🔒 Lock not acquired, another tab may have already processed the refresh');
                this.storage.removeItem(KEEP_ALIVE_LOCAL_STORAGE_NAME);
                this.initKeepAlive();
                return _context5.abrupt("return");
              case 10:
                if (!(result === 'ALREADY_REFRESHED')) {
                  _context5.next = 15;
                  break;
                }
                this.refreshRetryHandler.reset();
                this.storage.removeItem(KEEP_ALIVE_LOCAL_STORAGE_NAME);
                this.initKeepAlive();
                return _context5.abrupt("return");
              case 15:
                if (!(result === 'SUCCESS')) {
                  _context5.next = 20;
                  break;
                }
                this.refreshRetryHandler.reset();
                this.storage.removeItem(KEEP_ALIVE_LOCAL_STORAGE_NAME);
                this.initKeepAlive();
                return _context5.abrupt("return");
              case 20:
                _context5.next = 26;
                break;
              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5["catch"](1);
                console.error('KeepAlive lock ERROR during token refresh:', _context5.t0);
                if (this.refreshRetryHandler.canRetry()) {
                  retryCount = this.refreshRetryHandler.incrementRetry();
                  delay = this.refreshRetryHandler.getNextDelay();
                  console.warn("Keepalive refresh retry ".concat(retryCount, "/").concat(KEEPALIVE_REFRESH_MAX_RETRIES, " in ").concat(delay, "ms"));
                  setTimeout(function () {
                    _this3.refreshToken();
                  }, delay);
                } else {
                  console.error('Keepalive refresh max retries reached, attempting to reinitialize');
                  this.storage.removeItem(KEEP_ALIVE_LOCAL_STORAGE_NAME);
                  this.storage.removeItem(KEEP_ALIVE_REFRESH_TIMESTAMP_NAME);
                  this.refreshRetryHandler.reset();
                  this.initKeepAlive();
                }
              case 26:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this, [[1, 22]]);
        }));
        function refreshToken() {
          return _refreshToken.apply(this, arguments);
        }
        return refreshToken;
      }()
    }, {
      key: "redirectToAuthorize",
      value: function () {
        var _redirectToAuthorize = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          var callback, redirectUrl;
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                callback = "";
                _context6.prev = 2;
                _context6.next = 5;
                return this.storage.getCallbackUrl();
              case 5:
                callback = _context6.sent;
                _context6.next = 11;
                break;
              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](2);
                console.warn('Could not get location from main thread', _context6.t0);
              case 11:
                redirectUrl = KEEP_ALIVE_REDIRECT_URL + (callback ? encodeURIComponent(callback) : '');
                postMessage({
                  type: KEEPALIVE_REDIRECT_MESSAGE_TYPE,
                  url: redirectUrl
                });
                _context6.next = 19;
                break;
              case 15:
                _context6.prev = 15;
                _context6.t1 = _context6["catch"](0);
                console.error('Error during redirect to authorize', _context6.t1);
                postMessage({
                  type: KEEPALIVE_REDIRECT_MESSAGE_TYPE,
                  url: KEEP_ALIVE_REDIRECT_URL
                });
              case 19:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this, [[0, 15], [2, 8]]);
        }));
        function redirectToAuthorize() {
          return _redirectToAuthorize.apply(this, arguments);
        }
        return redirectToAuthorize;
      }()
    }, {
      key: "initKeepAlive",
      value: function () {
        var _initKeepAlive = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
          var _this4 = this;
          var timeoutDuration, retryCount, delay;
          return _regenerator["default"].wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                clearTimeout(this.keepAliveTimer);
                _context7.next = 3;
                return this.getTokenExpirationDate();
              case 3:
                this.expirationDate = _context7.sent;
                if (!this.expirationDate) {
                  _context7.next = 13;
                  break;
                }
                timeoutDuration = this.getTimeoutDuration();
                if (!(timeoutDuration < 0)) {
                  _context7.next = 9;
                  break;
                }
                console.error("Keepalive invalid timeout duration: ".concat(timeoutDuration, " - ").concat(this.expirationDate));
                return _context7.abrupt("return");
              case 9:
                this.keepAliveTimer = setTimeout(function () {
                  _this4.refreshToken();
                }, timeoutDuration);
                this.initRetryHandler.reset();
                _context7.next = 15;
                break;
              case 13:
                console.warn('Could not start keepalive, user not authenticated or an error has occurred');
                if (this.initRetryHandler.canRetry()) {
                  retryCount = this.initRetryHandler.incrementRetry();
                  delay = this.initRetryHandler.getNextDelay();
                  console.warn("Keepalive init retry ".concat(retryCount, "/").concat(KEEPALIVE_INIT_MAX_RETRIES, " in ").concat(delay, "ms"));
                  setTimeout(function () {
                    _this4.initKeepAlive();
                  }, delay);
                } else {
                  console.error('Keepalive initialization max retries reached, stopping');
                }
              case 15:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function initKeepAlive() {
          return _initKeepAlive.apply(this, arguments);
        }
        return initKeepAlive;
      }()
    }]);
  }();
  var WebLocksManager = /*#__PURE__*/function () {
    function WebLocksManager() {
      (0, _classCallCheck2["default"])(this, WebLocksManager);
      this.isLockSupported = this.checkWebLocksSupport();
    }
    return (0, _createClass2["default"])(WebLocksManager, [{
      key: "checkWebLocksSupport",
      value: function checkWebLocksSupport() {
        return typeof navigator !== 'undefined' && 'locks' in navigator;
      }
    }, {
      key: "acquireLockAndExecute",
      value: function () {
        var _acquireLockAndExecute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(lockName, callback) {
          var lockOptions, lockPromise;
          return _regenerator["default"].wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                if (this.isLockSupported) {
                  _context9.next = 5;
                  break;
                }
                console.warn('Web Locks API not supported, executing without lock');
                _context9.next = 4;
                return callback();
              case 4:
                return _context9.abrupt("return", _context9.sent);
              case 5:
                _context9.prev = 5;
                lockOptions = {
                  mode: 'exclusive',
                  ifAvailable: false
                };
                lockPromise = navigator.locks.request(lockName, lockOptions, /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(lock) {
                    var result;
                    return _regenerator["default"].wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          if (lock) {
                            _context8.next = 3;
                            break;
                          }
                          console.warn("Failed to acquire lock: ".concat(lockName));
                          return _context8.abrupt("return", null);
                        case 3:
                          console.log("\uD83D\uDD10 Lock acquired: ".concat(lockName));
                          _context8.prev = 4;
                          _context8.next = 7;
                          return callback();
                        case 7:
                          result = _context8.sent;
                          console.log("\uD83D\uDD13 Lock released: ".concat(lockName));
                          return _context8.abrupt("return", result);
                        case 12:
                          _context8.prev = 12;
                          _context8.t0 = _context8["catch"](4);
                          console.error("Error while holding lock ".concat(lockName, ":"), _context8.t0);
                          throw _context8.t0;
                        case 16:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8, null, [[4, 12]]);
                  }));
                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                _context9.next = 10;
                return lockPromise;
              case 10:
                return _context9.abrupt("return", _context9.sent);
              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](5);
                console.error("Web Locks API error for ".concat(lockName, ":"), _context9.t0);
                _context9.next = 18;
                return callback();
              case 18:
                return _context9.abrupt("return", _context9.sent);
              case 19:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this, [[5, 13]]);
        }));
        function acquireLockAndExecute(_x, _x2) {
          return _acquireLockAndExecute.apply(this, arguments);
        }
        return acquireLockAndExecute;
      }()
    }]);
  }();
  new KeepAliveWorker();
}